/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { createRabattcodesRouterDefinitions } from "../../Seminare/Routes/seminareRouterDefintions";
import { createBestellterArtikelRouterDefinitions } from "../../Teilnahmen/Routes/teilnahmenRouterDefintions";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VerticalSplit from "./../../../Basis/Components/VerticalSplit";

const AdressenKategorienView = React.lazy(() => import(/* webpackChunkName: "Adressen" */"../Views/AdressenKategorienView"));
const AdressenKategorieView = React.lazy(() => import(/* webpackChunkName: "Adressen" */"../Views/AdressenKategorieView"));
const AdressenKategorieDetailsView = React.lazy(() => import(/* webpackChunkName: "Adressen" */"../Views/AdressenKategorieDetailsView"));
const AdressenKategorienNavigationView = React.lazy(() => import(/* webpackChunkNames: "Adressen" */"../Views/AdressenKategorienNavigationView"));
const AdressenKategorienBreadcrumb = React.lazy(() => import(/* webpackChunkNames: "Adressen" */"../Components/AdressenKategorienBreadcrumb"));
const AdressenKategorieBreadcrumb = React.lazy(() => import(/* webpackChunkNames: "Adressen" */"../Components/AdressenKategorieBreadcrumb"));
const AdressenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Components/AdressenBreadcrumb"));
const AdressenView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Views/AdressenView"));
const AdresseTeilnahmenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Components/AdresseTeilnahmenBreadcrumb"));
const AdresseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Components/AdresseBreadcrumb"));
const AdressenNavigationView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Views/AdressenNavigationView"));
const AdresseView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Views/AdresseView"));
const AdresseDetailsView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Views/AdresseDetailsView"));
const AdresseFibuExporteView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Views/AdresseFibuExporteView"));
const AdresseFibuExporteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../Components/AdresseFibuExporteBreadcrumb"));
const TeilnahmenView = React.lazy(() => import(/* webpackChunkName: "Adressen" */ "../../Teilnahmen/Views/TeilnahmenView"));

export const ADRESSENKATEGORIENPATH = "/adresskategorien";

export const adressenRouterDefintions: Array<AppRouterDefinition> = [
    {
        path: ADRESSENKATEGORIENPATH,
        exact: true,
        render: (renderProps) => <AdressenKategorienView {...renderProps} />,
        createBreadcrumbs: () => [<AdressenKategorienBreadcrumb />],
    },
    {
        path: `${ADRESSENKATEGORIENPATH}/:kategorieId`,
        render: (renderProps) => (
            <VerticalSplit
                right={() => <AdressenKategorieView {...renderProps} />}
                left={() => <AdressenKategorienNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            <AdressenKategorienBreadcrumb />,
            <AdressenKategorieBreadcrumb kategorieId={createProps.kategorieId}/>]
    },
    {
        exact: true,
        path: `${ADRESSENKATEGORIENPATH}/:kategorieId`,
        parentPath: `${ADRESSENKATEGORIENPATH}/:kategorieId`,
        render: (renderProps) => <AdressenKategorieDetailsView {...renderProps}/>,
        createBreadcrumbs: (createProps) => [
            <AdressenKategorienBreadcrumb />,
            <AdressenKategorieBreadcrumb kategorieId={createProps.kategorieId}/>]
    },
    {
        path: "/adressen",
        render: (renderProps: any) => <AdressenView {...renderProps} />,
        createBreadcrumbs: () => [<AdressenBreadcrumb />],
    },
    {
        path: "/adresse/:adresseId",
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <AdresseView {...renderProps} />}
                left={() => <AdressenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <AdressenBreadcrumb />,
            <AdresseBreadcrumb adresseId={createProps.adresseId} />,
        ],
    },
    {
        exact: true,
        path: "/adresse/:adresseId/teilnahmen",
        parentPath: "/adresse/:adresseId",
        render: (renderProps: any) => <TeilnahmenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <AdressenBreadcrumb />,
            <AdresseBreadcrumb adresseId={createProps.adresseId} />,
            <AdresseTeilnahmenBreadcrumb adresseId={createProps.adresseId} />,
        ],
    },
    ...createRabattcodesRouterDefinitions(
        "/adresse/:adresseId",
        (props) => [<AdressenBreadcrumb />, <AdresseBreadcrumb {...props} />],
    ),
    {
        exact: true,
        parentPath: "/adresse/:adresseId",
        path: "/adresse/:adresseId/fibuexporte",
        render: props => <AdresseFibuExporteView {...props} />,
        createBreadcrumbs: props => [
            <AdressenBreadcrumb />,
            <AdresseBreadcrumb {...props} />,
            <AdresseFibuExporteBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/adresse/:adresseId",
        parentPath: "/adresse/:adresseId",
        render: (renderProps: any) => <AdresseDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <AdressenBreadcrumb />,
            <AdresseBreadcrumb adresseId={createProps.adresseId} />,
        ]
    },
    ...createBestellterArtikelRouterDefinitions(
        "/adresse/:adresseId",
        (props) => [
            <AdressenBreadcrumb />,
            <AdresseBreadcrumb adresseId={props.adresseId} />,
        ]),
]
